const Foto = () => {
  return (
    <div>Foto</div>
  )
}

export default Foto